<template>
  <div class="link-view">
    <h2>{{ isUpdateMode ? 'Refresh Account Credentials' : 'Link a New Account' }}</h2>
    <p v-if="loading">Loading Plaid Link...</p>
    <p v-if="error" class="error">{{ error }}</p>
    <button v-if="!loading && !error" @click="openPlaidLink" class="link-button">
      {{ isUpdateMode ? 'Update Credentials' : 'Connect Bank Account' }}
    </button>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import { API_ROOT, API_TOKEN } from '@/config';

export default defineComponent({
  name: "LinkView",
  data() {
    return {
      plaid: window.Plaid,
      loading: true,
      error: null,
      linkToken: null,
      plaidHandler: null,
      itemId: null,
    };
  },
  computed: {
    isUpdateMode() {
      return !!this.itemId;
    }
  },
  methods: {
    getToken() {
      let url = API_ROOT + '/link';
      if (this.itemId) {
        url += '?item_id=' + encodeURIComponent(this.itemId);
      }

      const request_data = {
        method: "GET",
        headers: new Headers({
          'Content-Type': 'application/json',
          'x-api-key': API_TOKEN
        }),
        mode: 'cors',
      };

      fetch(url, request_data)
        .then(result => result.json())
        .then(data => {
          this.linkToken = data['link_token'];
          this.initPlaidLink();
        })
        .catch(err => {
          this.error = 'Failed to get link token: ' + err.message;
          this.loading = false;
        });
    },
    initPlaidLink() {
      this.plaidHandler = this.plaid.create({
        token: this.linkToken,
        onSuccess: (public_token, metadata) => {
          this.saveToken(public_token, metadata);
        },
        onExit: (err, metadata) => {
          if (err) {
            console.error('Plaid Link error:', err);
          }
          console.log('Plaid Link exited:', metadata);
        },
      });
      this.loading = false;
    },
    openPlaidLink() {
      if (this.plaidHandler) {
        this.plaidHandler.open();
      }
    },
    saveToken(public_token, metadata) {
      const payload = {
        public_token,
        metadata,
        update_mode: this.isUpdateMode
      };
      if (this.isUpdateMode) {
        payload.item_id = this.itemId;
      }

      const request_data = {
        method: "POST",
        headers: new Headers({
          'Content-Type': 'application/json',
          'x-api-key': API_TOKEN
        }),
        mode: 'cors',
        body: JSON.stringify(payload)
      };

      fetch(API_ROOT + '/link', request_data)
        .then(result => result.json())
        .then(data => {
          console.log(this.isUpdateMode ? 'Credentials updated successfully:' : 'Account linked successfully:', data);
          this.$router.push("/");
        })
        .catch(err => {
          this.error = this.isUpdateMode ? 'Failed to update credentials: ' : 'Failed to save account: ' + err.message;
        });
    }
  },
  mounted() {
    if (!this.plaid) {
      this.error = 'Plaid SDK not loaded';
      this.loading = false;
      return;
    }
    // Check for update mode via query param
    this.itemId = this.$route.query.item_id || null;
    this.getToken();
  },
});
</script>

<style scoped>
.link-view {
  max-width: 400px;
  margin: 2rem auto;
  padding: 2rem;
  text-align: center;
}

.link-view h2 {
  margin-bottom: 1rem;
}

.link-button {
  background-color: #0066cc;
  color: white;
  border: none;
  padding: 0.75rem 1.5rem;
  font-size: 1rem;
  border-radius: 4px;
  cursor: pointer;
}

.link-button:hover {
  background-color: #0052a3;
}

.error {
  color: #dc3545;
}
</style>
